module.exports = __webpack_public_path__ + "static/w3-slider-mark-219f9652ee3beaf2c867d09dc8d68154.png";